import { render, staticRenderFns } from "./searchImageTeaser.vue?vue&type=template&id=2f1854cb&scoped=true&"
import script from "./searchImageTeaser.vue?vue&type=script&lang=js&"
export * from "./searchImageTeaser.vue?vue&type=script&lang=js&"
import style0 from "./searchImageTeaser.vue?vue&type=style&index=0&id=2f1854cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1854cb",
  null
  
)

export default component.exports